import { type RefObject, useEffect } from 'react';
import { type MyOCData } from '@cx-web/domain-types/myoc';

export const useLoginWall = ({
  componentTags,
  containerRef,
  myocData,
}: {
  componentTags: string[] | undefined;
  containerRef: RefObject<HTMLDivElement>;
  myocData: MyOCData;
}) => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const container = containerRef.current;
      if (!container) return;
      const iframe = document.querySelector('[data-widget-provider="q4-widget"]') as HTMLIFrameElement | null;

      if (!iframe) return;

      if (iframe.src.startsWith(event.origin)) {
        requestAnimationFrame(() => {
          iframe.style.height = `${event.data}px`;
        });
      }
    };

    window.addEventListener('message', handleMessage, false);
    return () => window.removeEventListener('message', handleMessage, false);
  }, []);
  const isLoggedIn = !!myocData.myOCUser;

  const shouldRenderLoginWall = !isLoggedIn && componentTags?.includes('TIPS_PREMIUM');

  return {
    myocData,
    shouldRenderLoginWall,
  };
};
